export const noDiagnosesText =
  'Não encontramos diagnósticos registrados nesse paciente. Adicione e utilize o campo CID 10 para utilizar essa funcionalidade.';

export const getDiagnosesErrorText =
  'Parece que estamos com problemas para carregar os últimos diagnósticos. Estamos trabalhando para a normalização.';

export const supportLinkRedirect =
  'https://suporte.iclinic.com.br/pt-br/destacar-ultimos-diagnosticos-do-paciente-no-prontuario-iclinic';
